import React from 'react';
import classNames from 'classnames';
import DataRoomEmptyImage from 'assets/images/data-room-empty-image.webp';
import { useTranslation } from 'react-i18next';
import ResolveImage from 'components/ResolveImage';
import CreateRfiActions from '../CreateRfiActions';

import './EmptyState.styles.scss';

type EmptyStateProps = {
  className?: string;
};

const EmptyState: React.FC<EmptyStateProps> = (props) => {
  const { className } = props;

  const { t } = useTranslation();

  const classes = classNames('empty-state', className);

  return (
    <div className={classes}>
      <ResolveImage
        src={DataRoomEmptyImage}
        asIllustration
        alt="No requests yet."
      />
      <p>{t('noFileRequestsHaveBeenCreated')}</p>

      <CreateRfiActions />
    </div>
  );
};

export default EmptyState;
